export const HISTORY_RANGES = [[30, '1 month'], [90, '3 months'], [180, '6 months'], [365, '1 year']];

// Explicit blank days prevent charts joining across outages or inventing prices
// before tracking began. UTC dates match the backend's daily snapshot keys.
export function dailyHistory(points, days, end = new Date().toISOString().slice(0, 10)) {
  const entries = new Map(points.map(point => [point.date, point]));
  const last = Date.parse(`${end}T00:00:00Z`);
  return Array.from({ length: days }, (_, index) => {
    const date = new Date(last - (days - 1 - index) * 86400000).toISOString().slice(0, 10);
    return entries.get(date) || { date };
  });
}
